@if (isCovidAlertMsgEnable) {
<nh-alert type="warning" [isOpen]="true">
  <div class="row">
    <div class="col-auto icon">
      <img
        src="../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
        alt=""
      />
    </div>
    <div class="col message">
      <span>
        {{ "COVID19_STIMULUS_CHECK_MSG" | globalTranslate }}
      </span>
    </div>
  </div>
</nh-alert>
} @if (isRmbRmc) {
<div>
  <span>{{ staticText | globalTranslate }}</span>
</div>
}<br />

@if (getValue('extras.topLevelAnswer') === 'YES') {
<div form-top>
  <h1 class="person-label" [attr.aria-hidden]="!selectedIndividual ? 'true' : null">
    {{ selectedIndividual | fullname }}
  </h1>
</div>
}
<div class="other-income">
  <nh-form
    [topLevelName]="'otin'"
    [individuals]="individuals"
    [formGroup]="getForm()"
    [mode]="mode"
    [topLevelQuestion]="conditionalTopLevelQuestion | globalTranslate"
    [popupText]="conditionalTopLevelTooltip | globalTranslate"
    individualQuestion="{{ this.individualQuestion | globalTranslate }}"
    hintText="{{ hintText | globalTranslate }}"
    (validate)="onValidate($event)"
    class="label-section"
  >
    <section [formGroup]="getControl('data')">
      <h2 class="section-header">
        {{ "OTHER_INCOME_SATIC_TEXT1" | globalTranslate }}
      </h2>
      <hr />

      <div [formGroup]="getControl('data.otherIncomeDetails')">
        <div class="hint">
          {{ "IF" | globalTranslate }} {{ selectedIndividual | fullname }}
          {{ otherIncomeTypeCodeHint | globalTranslate
          }}<b>{{ otherIncomeTypeCodeHintNext | globalTranslate }}</b>
        </div>
        <br />
        <div class="hint semibold">
          {{ otherIncomeTypeSSI | globalTranslate }}
        </div>
        <br />
        <nh-field
          id="otin_otherIncomeTypeCode"
          [label]="'OTHER_INCOME_SATIC_TEXT2' | globalTranslate"
          class="label-section"
        >
          <nh-popover
            field-label
            class="ml-2 ps-1"
            [content]="'OTHER_INCOME_TOOLTIP' | globalTranslate"
          ></nh-popover>
          @if (isFinReassessment) {
          <select
            nhTranslate
            name="otherIncomeTypeCode"
            [attr.aria-label]="'OTHER_INCOME_SATIC_TEXT2' | globalTranslate"
            (change)="onOtherIncomeTypeCodeChange()"
            [items]="
              tableCodeValue(
                'UNEARNEDINCOMETYPE_PP',
                'data.otherIncomeDetails.otherIncomeTypeCode'
              )
            "
            formControlName="otherIncomeTypeCode"
            [attr.disabled]="
              getControl('data.otherIncomeDetails.otherIncomeTypeCode').value
                ?.code === 'OT'
                ? true
                : null
            "
            aria-required="true"
          ></select>
          } @if (!isFinReassessment) {
          <select
            nhTranslate
            name="otherIncomeTypeCode"
            [attr.aria-label]="'OTHER_INCOME_SATIC_TEXT2' | globalTranslate"
            (change)="onOtherIncomeTypeCodeChange()"
            [items]="
              tableCodeValue(
                'UNEARNEDINCOMETYPE',
                'data.otherIncomeDetails.otherIncomeTypeCode'
              )
            "
            formControlName="otherIncomeTypeCode"
            [attr.disabled]="
              getControl('data.otherIncomeDetails.otherIncomeTypeCode').value
                ?.code === 'OT'
                ? true
                : null
            "
            aria-required="true"
          ></select>
          }
        </nh-field>

        @if (otherIncomeType === 'SOCIAL_SECURITY') {
        <nh-field
          id="otin_socialSecurityIncomeTypeCode"
          [label]="'OTHER_INCOME_SATIC_TEXT3' | globalTranslate"
          class="label-section"
        >
          <select
            nhTranslate
            name="socialSecurityIncomeTypeCode"
            [items]="
              tableCodeValue(
                'SSUNEARNEDINCOME',
                'data.otherIncomeDetails.socialSecurityIncomeTypeCode'
              )
            "
            formControlName="socialSecurityIncomeTypeCode"
            [attr.aria-label]="'OTHER_INCOME_SATIC_TEXT3' | globalTranslate"
          ></select>
        </nh-field>
        } @if (otherIncomeType === 'VETERAN') {
        <nh-field
          id="otin_veteranBenefitTypeCode"
          [label]="'OTHER_INCOME_SATIC_TEXT4' | globalTranslate"
          class="label-section"
        >
          <select
            nhTranslate
            name="veteranBenefitTypeCode"
            [attr.aria-label]="'OTHER_INCOME_SATIC_TEXT4' | globalTranslate"
            [items]="
              tableCodeValue(
                'VAUNEARNEDINCOME',
                'data.otherIncomeDetails.veteranBenefitTypeCode'
              )
            "
            formControlName="veteranBenefitTypeCode"
          ></select>
        </nh-field>
        } @if (otherIncomeType === 'ALIMONY') {
        <nh-field
          id="otin_alimonyOrderDate"
          [label]="'OTHER_INCOME_SATIC_TEXT5' | globalTranslate"
          class="label-section"
        >
          <nh-datepicker>
            <input
              type="text"
              class="form-control"
              [minDate]="minDate"
              [maxDate]="today"
              name="alimonyOrderDate"
              [attr.aria-label]="'OTHER_INCOME_SATIC_TEXT5' | globalTranslate"
              formControlName="alimonyOrderDate"
              bsDatepicker
              nh
            />
          </nh-datepicker>
        </nh-field>
        }
        <nh-field
          id="otin_paymentStartDate"
          label="{{ 'OTHER_INCOME_SATIC_TEXT6' | globalTranslate }} {{
            selectedIndividual | fullname
          }} {{ 'OTHER_INCOME_SATIC_TEXT7' | globalTranslate }} {{
            selectedOtherIncomeType.value | globalTranslate
          }}?"
          class="label-section"
        >
          <nh-datepicker>
            <input
              type="text"
              class="form-control"
              [minDate]="minDate"
              [maxDate]="endOfCurrentMonth"
              name="paymentStartDate"
              (change)="isInvalidStartDate($event)"
              [attr.aria-label]="
                ('OTHER_INCOME_SATIC_TEXT6' | globalTranslate) +
                ' ' +
                (selectedIndividual | fullname) +
                ' ' +
                ('OTHER_INCOME_SATIC_TEXT7' | globalTranslate) +
                ' ' +
                selectedOtherIncomeType.value +
                '?'
              "
              formControlName="paymentStartDate"
              bsDatepicker
              nh
              aria-required="true"
            />
          </nh-datepicker>
          @if (!errorMessageFuture && errorMessage) {
          <span class="form-text invalid-name invalid-date-bold d-block">{{
            "INVALID_DOB" | globalTranslate
          }}</span>
          } @if (!errorMessage && errorMessageFuture) {
          <span class="form-text invalid-name invalid-date-bold d-block">{{
            "INVALID_FUTURE_DATE" | globalTranslate
          }}</span>
          }
        </nh-field>

        @if (isEnabled('data.otherIncomeDetails.incomeEndSw')) {
        <nh-field
          id="otin_incomeEndSw"
          label="{{ 'OTHER_INCOME_SATIC_TEXT8' | globalTranslate }} {{
            selectedIndividual | fullname
          }}{{ 'OTHER_INCOME_SATIC_TEXT9' | globalTranslate }}"
          [mandatory]="false"
          [attr.aria-required]="false"
          class="label-section"
        >
          <select
            nhTranslate
            name="incomeEndSw"
            [attr.aria-label]="
              ('OTHER_INCOME_SATIC_TEXT8' | globalTranslate) +
              ' ' +
              (selectedIndividual | fullname) +
              ' ' +
              ('OTHER_INCOME_SATIC_TEXT9' | globalTranslate)
            "
            [items]="
              tableCodeValue('YESNO', 'data.otherIncomeDetails.incomeEndSw')
            "
            formControlName="incomeEndSw"
          ></select>
        </nh-field>
        } @if (isEnabled('data.otherIncomeDetails.incomeEndDate')) {
        <nh-field
          id="otin_incomeEndDate"
          label="{{ 'OTHER_INCOME_SATIC_TEXT6' | globalTranslate }} {{
            selectedIndividual | fullname
          }} {{ 'OTHER_INCOME_SATIC_TEXT10' | globalTranslate }} {{
            selectedOtherIncomeType.value | globalTranslate
          }} {{ 'OTHER_INCOME_SATIC_TEXT11' | globalTranslate }}"
          class="label-section"
        >
          <nh-datepicker>
            <input
              type="text"
              class="form-control"
              [minDate]="minimumcomeEndDate"
              [maxDate]="today"
              name="incomeEndDate"
              [attr.aria-label]="
                ('OTHER_INCOME_SATIC_TEXT6' | globalTranslate) +
                ' ' +
                (selectedIndividual | fullname) +
                ' ' +
                ('OTHER_INCOME_SATIC_TEXT10' | globalTranslate) +
                ' ' +
                selectedOtherIncomeType.value +
                ' ' +
                ('OTHER_INCOME_SATIC_TEXT11' | globalTranslate)
              "
              formControlName="incomeEndDate"
              bsDatepicker
              nh
              maxlength="10"
              aria-required="true"
            />
          </nh-datepicker>
        </nh-field>
        }

        <nh-field
          id="otin_paymentFrequency"
          label="{{ 'OTHER_INCOME_SATIC_TEXT12' | globalTranslate }} {{
            selectedIndividual | fullname
          }} {{ 'OTHER_INCOME_SATIC_TEXT13' | globalTranslate }} {{
            selectedOtherIncomeType.value | globalTranslate
          }}?"
          class="label-section"
        >
          <select
            nhTranslate
            name="paymentFrequency"
            [attr.aria-label]="
              ('OTHER_INCOME_SATIC_TEXT12' | globalTranslate) +
              ' ' +
              (selectedIndividual | fullname) +
              ' ' +
              ('OTHER_INCOME_SATIC_TEXT13' | globalTranslate) +
              ' ' +
              selectedOtherIncomeType.value +
              '?'
            "
            [items]="
              tableCodeValue(
                'INCEXPPAYFREQUENCY',
                'data.otherIncomeDetails.paymentFrequency'
              )
            "
            [attr.disabled]="isPaymentFrequencyDisabled ? 'disabled' : null"
            formControlName="paymentFrequency"
            aria-required="true"
          ></select>
        </nh-field>

        <nh-field
          id="otin_paymentAmount"
          label="{{ 'OTHER_INCOME_SATIC_TEXT14' | globalTranslate }}  {{
            selectedOtherIncomeType.value | globalTranslate
          }}?"
          class="label-section"
        >
          <nh-input-group prepend="$">
            <input
              nh
              type="text"
              placeholder="0.00"
              mask="separator.2"
              thousandSeparator=""
              separatorLimit="999999999"
              [attr.aria-label]="
                ('OTHER_INCOME_SATIC_TEXT14' | globalTranslate) +
                ' ' +
                selectedOtherIncomeType.value +
                '?'
              "
              name="paymentAmount"
              [attr.disabled]="disableAll"
              formControlName="paymentAmount"
              class="form-control"
              aria-required="true"
            />
          </nh-input-group>
        </nh-field>
      </div>
    </section>
    @if (otherIncomeType === 'SOCIAL_SECURITY') {
    <section [formGroup]="getControl('data.inKindData')">
      <div class="d-flex">
        <h2 class="section-header pt-1">
          {{ "OTHER_INCOME_SATIC_TEXT15" | globalTranslate }}
        </h2>
        <nh-popover
          class="ps-1 pt-1"
          [content]="'OTHER_INCOME_SATIC_TEXT20' | globalTranslate"
        ></nh-popover>
      </div>
      <hr />
      <nh-field
        id="otin_someOnePayFoodMonthly"
        label="{{ 'OTHER_INCOME_SATIC_TEXT16' | globalTranslate }} {{
          selectedIndividual | fullname
        }}{{ 'OTHER_INCOME_SATIC_TEXT17' | globalTranslate }}"
        class="label-section"
      >
        <select
          nhTranslate
          name="someOnePayFoodMonthly"
          [attr.aria-label]="
            ('OTHER_INCOME_SATIC_TEXT16' | globalTranslate) +
            ' ' +
            (selectedIndividual | fullname) +
            ' ' +
            ('OTHER_INCOME_SATIC_TEXT17' | globalTranslate)
          "
          (change)="onSomeOnePayFoodMonthlyChange()"
          [items]="
            tableCodeValue('YESNO', 'data.inKindData.someOnePayFoodMonthly')
          "
          formControlName="someOnePayFoodMonthly"
        ></select>
      </nh-field>
      <nh-field
        id="otin_someOnePayLivesMonthly"
        label="{{ 'OTHER_INCOME_SATIC_TEXT18' | globalTranslate }} {{
          selectedIndividual | fullname
        }}{{ 'OTHER_INCOME_SATIC_TEXT19' | globalTranslate }}"
        class="label-section"
      >
        <select
          nhTranslate
          name="someOnePayLivesMonthly"
          [attr.aria-label]="
            ('OTHER_INCOME_SATIC_TEXT18' | globalTranslate) +
            ' ' +
            (selectedIndividual | fullname) +
            ' ' +
            ('OTHER_INCOME_SATIC_TEXT19' | globalTranslate)
          "
          (change)="onSomeOnePayLivesMonthlyChange()"
          [items]="
            tableCodeValue('YESNO', 'data.inKindData.someOnePayLivesMonthly')
          "
          formControlName="someOnePayLivesMonthly"
        ></select>
      </nh-field>
      @if (isY('data.inKindData.someOnePayFoodMonthly') ||
      isY('data.inKindData.someOnePayLivesMonthly')) {
      <section>
        <div class="d-none d-lg-block">
          <table class="table w-100 table-striped">
            <thead>
              <tr>
                <th scope="col">
                  {{ "OTHER_INCOME_SATIC_TEXT21" | globalTranslate }}
                </th>
                <th scope="col">
                  {{ "OTHER_INCOME_SATIC_TEXT22" | globalTranslate }}
                </th>
                <th scope="col">
                  {{ "OTHER_INCOME_SATIC_TEXT23" | globalTranslate }}
                </th>
                <th scope="col">
                  {{ "OTHER_INCOME_SATIC_TEXT24" | globalTranslate }}
                </th>
                <th scope="col">
                  <span class="visually-hidden">Actions</span>
                </th>
              </tr>
            </thead>
            <tbody formArrayName="inkindSupportList">
              @for (row of inkindSupportList.controls; track row; let i =
              $index; let isLast = $last) {
              <tr [formGroupName]="i">
                <td>
                  <nh-field
                    id="otin_amountPerMonth"
                    [isRow]="true"
                    [mandatory]="true"
                    [attr.aria-required]="true"
                    [option]="amountPerMonthLabel"
                  >
                    <nh-input-group prepend="$">
                      <input
                        nh
                        type="text"
                        placeholder="0.00"
                        mask="separator.2"
                        thousandSeparator=""
                        separatorLimit="999999999"
                        name="amountPerMonth"
                        [attr.aria-label]="
                          'OTHER_INCOME_SATIC_TEXT21' | globalTranslate
                        "
                        formControlName="amountPerMonth"
                        class="form-control"
                      />
                    </nh-input-group>
                  </nh-field>
                </td>
                <td>
                  <nh-field
                    id="otin_expenseType"
                    [isRow]="true"
                    [mandatory]="true"
                    [attr.aria-required]="true"
                  >
                    <select
                      nhTranslate
                      name="expenseType"
                      [attr.aria-label]="
                        'OTHER_INCOME_SATIC_TEXT22' | globalTranslate
                      "
                      [items]="
                        tableCodeValue(
                          'ISMEXPENSETYPE',
                          inkindSupportList.controls[i]
                        )
                      "
                      formControlName="expenseType"
                    ></select>
                  </nh-field>
                </td>
                <td>
                  <nh-field
                    id="otin_amountPaidByInHome"
                    [isRow]="true"
                    [mandatory]="true"
                    [attr.aria-required]="true"
                    [option]="amountPaidByInHomeLabel"
                  >
                    <nh-input-group prepend="$">
                      <input
                        nh
                        type="text"
                        placeholder="0.00"
                        mask="separator.2"
                        thousandSeparator=""
                        separatorLimit="999999999"
                        name="amountPaidByInHome"
                        [attr.aria-label]="
                          'OTHER_INCOME_SATIC_TEXT23' | globalTranslate
                        "
                        formControlName="amountPaidByInHome"
                        class="form-control"
                      />
                    </nh-input-group>
                  </nh-field>
                </td>
                <td>
                  <nh-field
                    id="otin_amountPaidByOutHome"
                    [isRow]="true"
                    [mandatory]="true"
                    [attr.aria-required]="true"
                    [option]="amountPaidByOutHomeLabel"
                  >
                    <nh-input-group prepend="$">
                      <input
                        nh
                        type="text"
                        placeholder="0.00"
                        mask="separator.2"
                        thousandSeparator=""
                        separatorLimit="999999999"
                        name="amountPaidByOutHome"
                        [attr.aria-label]="
                          'OTHER_INCOME_SATIC_TEXT24 ' | globalTranslate
                        "
                        formControlName="amountPaidByOutHome"
                        class="form-control"
                      />
                    </nh-input-group>
                  </nh-field>
                </td>
                <td class="removeRow">
                  @if (i) {
                  <div class="pt-1 hover-red">
                    <button
                      class="btn btn-link btn-lg delete-{{ i }} hover-red p-1"
                      (click)="removeRow(i, row)"
                    >
                      <span class="pe-2">{{ "REMOVE" | globalTranslate }}</span>
                      <nh-remove-svg></nh-remove-svg>
                    </button>
                  </div>
                  }
                </td>
              </tr>
              }
              <tr>
                <td colspan="5">
                  <div class="mt-1 hover-red add-another-left">
                    <button
                      class="btn btn-link btn-lg hover-red"
                      (click)="addRow()"
                      [disabled]="
                        !getControl('data.inKindData.inkindSupportList').valid
                      "
                    >
                      <span class="pe-2">{{ "ADD_2" | globalTranslate }}</span>
                      <nh-add-svg></nh-add-svg>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="nh-table-mobile mt-3 pt-2 d-lg-none">
          <div formArrayName="inkindSupportList">
            @for (row of inkindSupportList.controls; track row; let i = $index;
            let isLast = $last) {
            <div class="table-row mb-3 pb-3" [formGroupName]="i">
              <div class="mobile-table-header">
                {{ "OTHER_INCOME_SATIC_TEXT21" | globalTranslate }}
              </div>
              <hr />
              <div class="mobile-table-data">
                <nh-field
                  id="otin_amountPerMonth"
                  [isRow]="true"
                  [mandatory]="true"
                  [attr.aria-required]="true"
                  [option]="amountPerMonthLabel"
                >
                  <nh-input-group prepend="$">
                    <input
                      nh
                      type="text"
                      placeholder="0.00"
                      mask="separator.2"
                      thousandSeparator=""
                      separatorLimit="999999999"
                      name="amountPerMonth"
                      [attr.aria-label]="
                        'OTHER_INCOME_SATIC_TEXT21' | globalTranslate
                      "
                      formControlName="amountPerMonth"
                      class="form-control"
                    />
                  </nh-input-group>
                </nh-field>
              </div>
              <br />
              <div class="mobile-table-header">
                {{ "OTHER_INCOME_SATIC_TEXT22" | globalTranslate }}
              </div>
              <hr />
              <div class="mobile-table-data">
                <nh-field
                  id="otin_expenseType"
                  [isRow]="true"
                  [mandatory]="true"
                  [attr.aria-required]="true"
                >
                  <select
                    nhTranslate
                    name="expenseType"
                    [attr.aria-label]="
                      'OTHER_INCOME_SATIC_TEXT22' | globalTranslate
                    "
                    [items]="
                      tableCodeValue(
                        'ISMEXPENSETYPE',
                        inkindSupportList.controls[i]
                      )
                    "
                    formControlName="expenseType"
                  ></select>
                </nh-field>
              </div>
              <br />
              <div class="mobile-table-header">
                {{ "OTHER_INCOME_SATIC_TEXT23" | globalTranslate }}
              </div>
              <hr />
              <div class="mobile-table-data">
                <nh-field
                  id="otin_amountPaidByInHome"
                  [isRow]="true"
                  [mandatory]="true"
                  [attr.aria-required]="true"
                  [option]="amountPaidByInHomeLabel"
                >
                  <nh-input-group prepend="$">
                    <input
                      nh
                      type="text"
                      placeholder="0.00"
                      mask="separator.2"
                      thousandSeparator=""
                      separatorLimit="999999999"
                      name="amountPaidByInHome"
                      [attr.aria-label]="
                        'OTHER_INCOME_SATIC_TEXT23' | globalTranslate
                      "
                      formControlName="amountPaidByInHome"
                      class="form-control"
                    />
                  </nh-input-group>
                </nh-field>
              </div>
              <br />
              <div class="mobile-table-header">
                {{ "OTHER_INCOME_SATIC_TEXT24" | globalTranslate }}
              </div>
              <hr />
              <div class="mobile-table-data">
                <nh-field
                  id="otin_amountPaidByOutHome"
                  [isRow]="true"
                  [mandatory]="true"
                  [attr.aria-required]="true"
                  [option]="amountPaidByOutHomeLabel"
                >
                  <nh-input-group prepend="$">
                    <input
                      nh
                      type="text"
                      placeholder="0.00"
                      mask="separator.2"
                      thousandSeparator=""
                      separatorLimit="999999999"
                      name="amountPaidByOutHome"
                      [attr.aria-label]="
                        'OTHER_INCOME_SATIC_TEXT24' | globalTranslate
                      "
                      formControlName="amountPaidByOutHome"
                      class="form-control"
                    />
                  </nh-input-group>
                </nh-field>
              </div>
              @if (i) {
              <div class="pt-1 hover-red text-center">
                <br />
                <button
                  class="btn btn-link btn-lg delete-{{ i }} hover-red p-1"
                  (click)="removeRow(i, row)"
                >
                  <span class="pe-2">{{ "REMOVE" | globalTranslate }}</span>
                  <nh-remove-svg></nh-remove-svg>
                </button>
              </div>
              }<br />
            </div>
            }
          </div>
          <div class="pt-1 hover-red text-start">
            <button
              class="btn btn-link btn-lg hover-red"
              (click)="addRow()"
              [disabled]="
                !getControl('data.inKindData.inkindSupportList').valid
              "
            >
              <span class="pe-2">{{ "ADD_2" | globalTranslate }}</span>
              <nh-add-svg></nh-add-svg>
            </button>
          </div>
        </div>
        <nh-field
          id="otin_liveWithOtherAdults"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="{{ 'DOES_2' | globalTranslate }}{{
            selectedIndividual | fullname
          }} {{ 'OTHER_INCOME_SATIC_TEXT25' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            name="liveWithOtherAdults"
            [attr.aria-label]="
              ('DOES_2' | globalTranslate) +
              ' ' +
              (selectedIndividual | fullname) +
              ' ' +
              ('OTHER_INCOME_SATIC_TEXT25' | globalTranslate)
            "
            [items]="
              tableCodeValue('YESNO', 'data.inKindData.liveWithOtherAdults')
            "
            formControlName="liveWithOtherAdults"
          ></select>
        </nh-field>
        @if (isEnabled('data.inKindData.paidHouseholdExpenseAmt')) {
        <nh-field
          id="otin_paidHouseholdExpenseAmt"
          label="{{ 'OTHER_INCOME_SATIC_TEXT26' | globalTranslate }} {{
            selectedIndividual | fullname
          }} {{ 'OTHER_INCOME_SATIC_TEXT27' | globalTranslate }}"
          class="label-section"
        >
          <nh-input-group prepend="$">
            <input
              nh
              type="text"
              placeholder="0.00"
              mask="separator.2"
              thousandSeparator=""
              separatorLimit="999999999"
              name="paidHouseholdExpenseAmt"
              [attr.aria-label]="
                ('OTHER_INCOME_SATIC_TEXT26' | globalTranslate) +
                ' ' +
                (selectedIndividual | fullname) +
                ' ' +
                ('OTHER_INCOME_SATIC_TEXT27' | globalTranslate)
              "
              formControlName="paidHouseholdExpenseAmt"
              class="form-control"
              aria-required="true"
            />
          </nh-input-group>
        </nh-field>
        }
        <nh-field
          id="otin_howManyPeopleLive"
          [mandatory]="false"
          [attr.aria-required]="false"
          label="{{ 'OTHER_INCOME_SATIC_TEXT28' | globalTranslate }} {{
            selectedIndividual | fullname
          }}{{ 'OTHER_INCOME_SATIC_TEXT29' | globalTranslate }}"
          class="label-section"
        >
          <nh-popover
            class="ps-1"
            [content]="'OTHER_INCOME_SATIC_TEXT30' | globalTranslate"
          ></nh-popover>
          <input
            type="text"
            name="howManyPeopleLive"
            [attr.aria-label]="
              ('OTHER_INCOME_SATIC_TEXT28' | globalTranslate) +
              ' ' +
              (selectedIndividual | fullname) +
              ' ' +
              ('OTHER_INCOME_SATIC_TEXT29' | globalTranslate)
            "
            formControlName="howManyPeopleLive"
            mask="9999"
            class="form-control"
          />
        </nh-field>
      </section>
      }
    </section>
    }
  </nh-form>
</div>
